export const ru = {
    'feedback-already-exists':
        'На одного специалиста можно оставить только один отзыв. Отредактируйте, пожалуйста, свой отзыв, оставленный ранее',
    'feedback-not-found':
        'Редактируемый отзыв не найден в нашей базе данных. Попробуйте обновить страницу и попробовать еще раз',
    'incorrect-feedback-text-size':
        'Комментарий к отзыву должен быть не меньше трех символов.',
    'operator-has-no-project-with-freelancer':
        'Вы не сможете оставить отзыв на этого специалиста, поскольку у вас нет действующего или завершённого сотрудничества с ним.',
    'operator-has-wrong-role':
        'Вы не можете оставлять отзывы на специалистов Яндекс.Директа',
    'operator-is-not-chief':
        'Вы не можете оставлять отзывы на специалистов Яндекс.Директа'
};
